import {
  CSSObjectWithLabel,
  ControlProps,
  DropdownIndicatorProps,
  GroupBase,
  components,
} from 'react-select'
import { OptionType } from '../../../app/utils/optionSelectType'

export const FilterSelectStyle = ({ isMulti = true }) => {
  const DropdownIndicator = (
    props: DropdownIndicatorProps<
      OptionType,
      typeof isMulti,
      GroupBase<OptionType>
    >,
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <i className="fa-solid fa-chevron-down text-black"></i>
      </components.DropdownIndicator>
    )
  }

  const customStyles = {
    control: (
      base: CSSObjectWithLabel,
      props: ControlProps<OptionType, typeof isMulti, GroupBase<OptionType>>,
    ): CSSObjectWithLabel => ({
      ...base,
      borderRadius: '6px',
      border: props.isFocused
        ? '2px solid black'
        : '1px solid hsl(var(--input))',
      boxShadow: 'black',
      '&:hover': {
        border: '1px solid hsl(var(--input))',
      },
    }),
    placeholder: (base: CSSObjectWithLabel) => ({
      ...base,
      color: 'black',
    }),
  }

  return {
    DropdownIndicator,
    customStyles,
  }
}
